import { AxiosError, AxiosResponse } from "axios";
import { IExpensesData } from "../../interfaces/IExpenses";
import nodeProvider from "../providers/node.provider";
import protheusProvider from "../providers/protheus.provider";
import { decode } from "base-64";

interface IRestPassword {
  token: string;
  password: string;
}

export class ForgetPasswordService {
  public async forgetService(user: string, sendBy: string): Promise<AxiosResponse> {
    try {
      const response = await nodeProvider.post('/forgot-password', {
        email: decode(user)
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async newPassword(objectParams: IRestPassword): Promise<AxiosResponse> {
    try {
      const response = await nodeProvider.post('/reset-password', objectParams);
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async codeValidate(user: string, code: string): Promise<AxiosResponse> {
    try {
      const response = await nodeProvider.post('/validate-code', {
        email: decode(user),
        code
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }
}